<template>
    <div class="complectation-element-manage flex flex-col">
        <div class="title flex justify-between items-center">
            <span>{{ $t(`client.${element_group}.title`) }}</span>
            <button
                @click="$store.dispatch('clientMain/setManageElement', null)"
            >
                <i class="fas fa-times"></i>
            </button>
        </div>
        <div class="body flex-1 overflow-x-hidden">
            <div class="manage-step">
                <div class="manage-step-title">
                    {{ $t("main.select_model") }}
                </div>
                <!-- select element and load that detail -->
                <div class="manage-step-body">
                    <div class="element-list-types" v-if="types.length">
                        <div
                            class="choose-element-type"
                            v-for="(type, ndx) in types"
                            :key="`element-type-${ndx}`"
                        >
                            <div class="choose-element-type-title">
                                <button
                                    class="flex justify-between items-center focus:outline-none w-full"
                                    @click="showElementsByType(type)"
                                >
                                    <span class="img-txt flex items-center">
                                        <span
                                            class="img flex justify-between items-center"
                                            ><img :src="type.image" alt=""
                                        /></span>
                                        <span class="txt ml-2">{{
                                            type.name
                                        }}</span>
                                    </span>
                                    <span
                                        class="arrow-down"
                                        :class="{
                                            rotate: types[ndx].showElements,
                                        }"
                                        style="
                                            background-image: url('/images/icons/icon-right-arrow.svg');
                                        "
                                    >
                                    </span>
                                </button>
                            </div>
                            <Loading v-if="loadingElements[type.type_id]" />

                            <ElementSidebarElements
                                :id="`elements__root-${type.type_id}`"
                                v-if="
                                    (types[ndx].showElements &&
                                        type.elements.length > 0) ||
                                    (selected &&
                                        type.type_id == selected.type_id &&
                                        types[ndx].showElements)
                                "
                                :type="type"
                                :selected="selected"
                                @mountedElements="
                                    setLoadingObserver(type.type_id)
                                "
                            />
                        </div>
                    </div>
                    <!-- Removed extra elements block that was duplicating content -->
                </div>
            </div>
            <!-- if element -->
            <div
                class="manage-step"
                v-if="selected && selected.sizes.length > 0"
            >
                <div class="manage-step-title">
                    {{ $t("main.select_size") }}
                </div>
                <div class="manage-step-body">
                    <select
                        ref="elementSelectSize"
                        id="type_id"
                        @change="
                            $store.dispatch('clientOrder/updateElementSize', {
                                size: selected.sizes.find(
                                    (size) =>
                                        size.element_size_id ==
                                        $refs.elementSelectSize.value
                                ),
                                element_id: selected.element_id,
                            })
                        "
                    >
                        <option
                            v-for="size in selected.sizes"
                            :key="`element-size-${size.element_size_id}`"
                            :value="size.element_size_id"
                            :selected="
                                selected &&
                                selected.size &&
                                selected.size.element_size_id ==
                                    size.element_size_id
                            "
                        >
                            {{ size.height }} x {{ size.width }} x
                            {{ size.length }}
                        </option>
                    </select>
                </div>
            </div>
            <!-- if element.size -->
            <div
                class="manage-step"
                v-if="
                    selected &&
                    selected.materials.length > 0 &&
                    selected.type_calc_cost !== 'fix'
                "
            >
                <div class="manage-step-title">
                    {{ $t("main.select_material") }}
                </div>
                <div class="manage-step-body">
                    <div
                        class="selected-elements-material flex justify-between items-center"
                        v-if="selected.material"
                    >
                        <div class="flex items-center">
                            <div class="thumb">
                                <img
                                    class="object-cover"
                                    :src="selected.material.image"
                                    alt=""
                                />
                            </div>
                            <div class="name ml-2">
                                {{ selected.material.name }}
                            </div>
                        </div>

                        <div
                            class="cost-coefficient"
                            v-if="
                                selected.material.cost_coefficient &&
                                selected.type_calc_cost == 'coef'
                            "
                        >
                            [ коэф. {{ selected.material.cost_coefficient }} ]
                        </div>
                    </div>
                    <div
                        class="choose-element-list flex items-start flex-wrap overflow-x-hidden"
                    >
                        <button
                            @click="
                                $store.dispatch(
                                    'clientOrder/updateElementMaterial',
                                    {
                                        element_id: selected.element_id,
                                        material,
                                    }
                                )
                            "
                            class="choose-element-item relative focus:outline-none"
                            :class="{
                                selected:
                                    selected.material &&
                                    selected.material.material_id ==
                                        material.material_id,
                            }"
                            v-for="(material, mndx) in selected.materials"
                            :key="`choose-element-material-${mndx}`"
                        >
                            <i
                                class="fas fa-check absolute top-2 right-2"
                                v-if="
                                    selected.material &&
                                    selected.material.material_id ==
                                        material.material_id
                                "
                            ></i>
                            <div class="img">
                                <img
                                    class="object-cover"
                                    :src="material.image"
                                    alt=""
                                />
                            </div>
                        </button>
                    </div>
                </div>
            </div>
            <!-- if element.size -->
            <div class="manage-step" v-if="showPolish">
                <div class="manage-step-title">{{ $t("main.polishing") }}</div>
                <div class="manage-step-body">
                    <div class="polishes">
                        <polish-card
                            :polish="polish"
                            :selected="selected"
                            v-for="polish in polishes"
                            :key="`polish-${polish.id}`"
                        />
                    </div>
                </div>
            </div>
            <!-- if element.size -->
            <div class="manage-step" v-if="showServices">
                <div class="manage-step-title">
                    {{ $t("main.additional_services") }}
                </div>
                <div class="manage-step-body">
                    <div class="services">
                        <service-card
                            :service="service"
                            :selected="selected"
                            v-for="service in services"
                            :key="`service-${service.id}`"
                        />
                    </div>
                </div>
            </div>

            <div
                class="next-step"
                v-if="selected && selected.faces && selected.faces.length"
            >
                <router-link class="next-step-button" :to="engravingRoute">{{
                    $t("main.next")
                }}</router-link>
            </div>
        </div>
    </div>
</template>
<script>
import ElementSidebarElements from "./ElementSidebar/ElementSidebarElements.vue";
import PolishCard from "./Polish/PolishCard.vue";
import ServiceCard from "./Services/ServiceCard.vue";
export default {
    components: { PolishCard, ServiceCard, ElementSidebarElements },
    name: "ElementsSidebar",
    props: {
        element_group: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            selectType: {
                page: 1,
                perPage: 24,
                typeId: 0,
                elements: [],
            },
        };
    },
    methods: {
        async showElementsByType(type) {
            if (type.showElements) {
                this.$store.dispatch(
                    "clientElements/clearTypeElements",
                    type.type_id
                );
            } else {
                await this.$store.dispatch(
                    "clientElements/getElementsByType",
                    type.type_id
                );
            }

            this.$store.dispatch("clientElements/setTypeShowElements", {
                typeId: type.type_id,
                show: !type.showElements,
            });
        },

        setLoadingObserver(typeId) {
            const element = document.getElementById(
                `elements__loader-${typeId}`
            );
            const rootElement = document.getElementById(
                `elements__root-${typeId}`
            );

            if (rootElement && element) {
                const loadingObserver = new IntersectionObserver(
                    async (entries) => {
                        entries.forEach(async (entry) => {
                            if (entry.isIntersecting) {
                                await this.$store.dispatch(
                                    "clientElements/getElementsByType",
                                    typeId
                                );
                            }
                        });
                    },
                    {
                        root: rootElement,
                        threshold: 0.5,
                    }
                );
                loadingObserver.observe(element);
            }
        },
    },
    computed: {
        engravingRoute() {
            let route = { name: "engraving" };

            if (this.$route.query && this.$route.query.order_cache) {
                route = {
                    ...route,
                    query: { order_cache: this.$route.query.order_cache },
                };
            }
            return route;
        },
        showPolish() {
            if (
                this.settings.use_polish == "1" &&
                this.selected &&
                this.polishes &&
                this.polishes.length
            )
                return true;
            return false;
        },
        showServices() {
            if (
                this.element_group == "vazy" ||
                this.element_group == "stoliki" ||
                this.element_group == "skameiki"
            ) {
                return false;
            }
            if (
                this.settings.use_services == "1" &&
                this.selected &&
                this.services &&
                this.services.length
            ) {
                return true;
            }
        },
        settings() {
            return this.$store.state.settings.settings;
        },
        types() {
            return this.$store.state.clientElements.types;
        },
        elements() {
            return this.$store.state.clientElements.elements;
        },
        loadingElements() {
            return this.$store.state.clientElements.loadingElements;
        },
        polishes() {
            return this.$store.state.clientAdditionalWorks.additionalWorks
                .polish[this.element_group];
        },
        services() {
            return this.$store.state.clientAdditionalWorks.additionalWorks
                .service;
        },
        selected() {
            return this.$store.getters["clientOrder/selectedElement"](
                this.element_group
            );
        },
    },
};
</script>

<style scoped>
.arrow-down {
    width: 20px;
    height: 20px;
    display: block;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    transition: transform 0.3s ease;
}
.arrow-down.rotate {
    transform: rotate(90deg);
}

@media screen and (max-width: 1000px) {
    .complectation-element-manage {
        width: 300px;
    }
}
</style>
<style>
@media screen and (max-width: 1000px) {
    .complectation-element-manage
        .manage-step
        .choose-element-type
        .choose-element-type-list-element,
    .complectation-element-manage .choose-element-list .choose-element-item {
        width: 112px;
        min-height: 112px;
    }
    .choose-element-type-title .txt {
        font-size: 13px;
        text-align: left;
    }
}
</style>
